import "bootstrap/dist/css/bootstrap.min.css";
import Chat from "./Chat";

function App() {
  return <Chat />;
}

export default App;
